import { observable, action, makeObservable } from 'mobx';
import { InputType, PropListType } from './types';

export class PropListInput implements PropListType {
  dataType: string;

  label: string;

  placeholder?: string;

  tag: string;

  @observable selectorValue!: InputType | null;

  @observable value!: Record<string, any>[];

  error: string;

  @observable disabled: boolean;

  required: boolean;

  route: string = '';

  isKey: boolean = false;

  isEdit: boolean = false;

  // eslint-disable-next-line react/static-property-placement
  props: InputType[] = [];

  constructor({
    tag,
    label,
    placeholder,
    dataType,
    error,
    disabled,
    required,
    route = '',
    isKey = false,
    isEdit = false,
    props = [],
  }: any) {
    this.dataType = dataType;
    this.label = label;
    this.tag = tag;
    this.placeholder = placeholder;
    this.error = error;
    this.disabled = disabled;
    this.required = required;
    this.route = route;
    this.isKey = isKey;
    this.isEdit = isEdit;
    makeObservable(this);
    this.onChange(null); // set initial value
    this.onChangeValue([]); // set initial value
    this.props = props;
  }

  // onChange do not change the value, only the selecion
  @action
  onChange = (v: InputType | null) => {
    this.selectorValue = v;
  };

  // onChangeValue changes the array
  @action
  onChangeValue = (v: Record<string, any>[]) => {
    this.value = v;
    this.selectorValue = null;
  };

  @action
  clearValue = () => {
    this.selectorValue = null;
    this.value = [];
  };

  @action
  toggleDisabled = () => {
    this.disabled = !this.disabled;
  };
}
